module.exports = __webpack_public_path__ + "img/governorates.532f350e.svg";